/* eslint-disable react/prop-types */
import React from 'react';

const DeleteTutorialForm = ({ currentPDF }) => {
  return (
    <div>
      <p>
        ¿Estás seguro de eliminar el tutorial <strong>{currentPDF.name}</strong>
        ?
      </p>
    </div>
  );
};

export default DeleteTutorialForm;
